export const ITEMS_PER_PAGE = {
	DEFAULT: 25,
	DOUBLE: 50,
};
